import annotationTypes from 'react-scale/components/tailwind/product-examples/examples';
import ExampleContent from 'react-scale/components/tailwind/product-examples/ExampleContent';

const HowItWorks = () => (
  <div className="xl:h-[395px]">
    <ExampleContent
      code={annotationTypes.launch[0].example.code}
      response={annotationTypes.launch[0].example.response}
      example={annotationTypes.launch[0].example.example}
      result={annotationTypes.launch[0].example.result}
      jsonResult={false}
      responseDelay={annotationTypes.launch[0].responseDelay || 1}
      theme="dark"
    />
  </div>
);

export default HowItWorks;
